<style lang="scss" scoped>
.handle {
  padding: 25px;
  .handle-row {
    width: 100%;
  }
  .empty {
    padding: 20px;
  }
}
</style>

<template>
  <div class="maintenance-box">
    <div class="panel">
      <el-row class="handle" :gutter="20">
        <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
          <el-button :disabled="btnStatus" class="handle-row" type="primary" @click="handlePageChange(1)">{{ reuse.refresh }}</el-button>
        </el-col>
        <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" v-loading="realtimeDownload">
          <el-button :disabled="btnStatus" class="handle-row" @click="download">{{ language.nowDownload }}</el-button>
        </el-col>
        <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" v-loading="dailyDownload">
          <el-button class="handle-row" @click="downloadDaily">{{ language.endOfDayDownload }}</el-button>
        </el-col>
        <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
          <el-date-picker :picker-options="pickerOptions" :placeholder="language.placeholder" class="handle-row" type="date" v-model="dayOfReport" value-format="yyyy-MM-dd"></el-date-picker>
        </el-col>
      </el-row>
      <el-row v-loading="loadAccInfo">
        <el-table :data="plData" border>
          <template v-for="(v, i) in tableColumns">
            <el-table-column :fixed="v.fixed" :width="160" :prop="v.key" :label="v.value" :key="i"> 
                <template slot-scope="scope">
                    <span v-if="v.redColor" :style="+scope.row[v.key] < 0 ? 'color:red;':''">{{ scope.row[v.key] }}</span>
                    <span v-else>{{ scope.row[v.key] }}</span>
                </template>
            </el-table-column>
          </template>
        </el-table>
      </el-row>
      <el-row class="handle">
        <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
          <div class="empty"></div>
        </el-col>
        <el-col :lg="9" :md="9" :sm="9" :xl="9" :xs="9">
          <el-pagination
            :current-page="pageNum"
            :page-size="pageSize"
            :page-sizes="[5, 10, 25, 50]"
            :pager-count="5"
            :total="total"
            @current-change="handlePageChange"
            @size-change="handleSizeChange"
            layout="sizes, prev, pager, next"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { URL_FLOATING_PL } from 'api/api'

const mixins = [require('common/mixin/base').base({ language: 'floatingPL' }), require('common/mixin/base').base({ reuse: 'reuse' })]

const data = () => {
  return {
    plData: [],
    dayOfMT4Now: null,
    pageNum: 1,
    pageSize: 10,
    total: 0,
    btnStatus: false,
    dayOfReport: null,
    loadAccInfo: false,
    realtimeDownload: false,
    dailyDownload: false,
    pickerOptions: {
      disabledDate(time) {
        let now = new Date()
        now.setTime(now.getTime() - 24 * 36e5)
        let oneMonthBefore = new Date()
        oneMonthBefore.setTime(oneMonthBefore.getTime() - 720 * 36e5)
        return time.getTime() > now || oneMonthBefore > time.getTime() || [0, 6].includes(time.getDay())
      },
    },
  }
}

const computed = {
    tableColumns() {
        const redColorColumns = [
            'DEPOSIT','WITHDRAWAL','EQUITY','PREVIOUS_FLOATING_PL','FLOATING_PL','CLOSED_PL',
            'CLOSED_SWAPS','ADJUSTMENT','CLOSED_COMMISSION','IB_COMMISSION','CL_F_PL'
        ]
        this.language.tableColumns.forEach(head => {
            if(redColorColumns.includes(head.key)) head.redColor = true;
        })
        return this.language.tableColumns
    }
}

const created = function () {
  const userTime = this.$moment()
  const tzOfMT4 = sessionStorage.getItem('MT4TimeZone') || 3
  const tzOfUser = userTime.utcOffset() / 60
  const mt4Time = userTime.add(tzOfMT4 - tzOfUser, 'h')
  this.dayOfMT4Now = mt4Time.format('YYYY-MM-DD')
  const mt4Weekday = mt4Time.weekday()
  const subDays = { 0: 2, 1: 3 }
  this.dayOfReport = mt4Time.subtract(subDays[mt4Weekday] || 1, 'd').format('YYYY-MM-DD')
  if ([0, 6].includes(mt4Weekday)) this.btnStatus = true
  else this.getFloatingPL()
}

const methods = {
  getFloatingPL() {
    this.loadAccInfo = true
    this.$http.post(URL_FLOATING_PL, { dayOfMT4Now: this.dayOfMT4Now, pageNum: this.pageNum, pageSize: this.pageSize }).then((res) => {
      const result = res.data.data
      this.plData = result
      this.loadAccInfo = false
      const addPageNum = result.length == this.pageSize ? 1 : 0
      this.total = this.pageSize * (this.pageNum + addPageNum)
    })
  },
  handlePageChange(val) {
    this.pageNum = val
    this.getFloatingPL()
  },
  handleSizeChange(val) {
    this.pageNum = 1
    this.pageSize = val
    this.getFloatingPL()
  },
  download() {
    this.realtimeDownload = true
    this.$http.post(URL_FLOATING_PL, { dayOfMT4Now: this.dayOfMT4Now, pageSize: -1 }).then((res) => {
      this.export2Excel(res.data.data, this.language.excelName)
      this.realtimeDownload = false
    })
  },
  downloadDaily() {
    if (this.dayOfReport === null) {
      this.$message.warning(this.language.warning)
      return
    }
    this.dailyDownload = true
    this.$http.post(URL_FLOATING_PL, { dayOfReport: this.dayOfReport, pageSize: -1 }).then((res) => {
      this.export2Excel(res.data.data, `${this.language.excelName}_${this.dayOfReport}`)
      this.dailyDownload = false
    })
  },
  export2Excel(datas, excelName) {
    require.ensure([], () => {
      const { export_json_to_excel } = require('@/vendor/Export2Excel')
      const tHeader = this.language.tableColumns.map((v) => v.value)
      const filterVal = this.language.tableColumns.map((v) => v.key)
      const data = datas.map((v) => filterVal.map((j) => v[j]))
      export_json_to_excel(tHeader, data, excelName, { moneyStyle: '#,##0.00;[Red](#,##0.00)' })
    })
  },
}

export default {
  mixins,
  data,
  computed,
  created,
  methods,
}
</script>


// WEBPACK FOOTER //
// src/views/manager-report/floatingpl-report.vue